import { Box, Button } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

interface AddInvoiceButtonProps {

}

const AddInvoiceButton: FC<AddInvoiceButtonProps> = () => {
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={4}
            mt={2}
        >
            <Button
                variant="contained"
                size="large"
                sx={{
                    px: 7,
                    py: 2.2,
                    borderRadius: 12,
                    fontWeight: 900,
                    fontSize: 24,
                    letterSpacing: 1.5,
                    color: "#fff",
                    background: "linear-gradient(100deg, #8EC5FC 0%, #E0C3FC 100%)",
                    boxShadow: "0 6px 32px 0 rgba(142,197,252,0.18), 0 2px 12px 0 rgba(224,195,252,0.10)",
                    textTransform: "none",
                    position: "relative",
                    overflow: "hidden",
                    transition: "background 0.25s, box-shadow 0.18s, transform 0.13s",
                    border: "2.5px solid #fff",
                    outline: "2px solid #e0c3fc",
                    outlineOffset: "-4px",
                    "&:before": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: 0,
                        width: "100%",
                        height: "100%",
                        background: "radial-gradient(circle at 70% 30%, rgba(255,255,255,0.22) 0%, rgba(224,195,252,0.10) 100%)",
                        opacity: 0.8,
                        zIndex: 0,
                        pointerEvents: "none",
                    },
                    "&:hover": {
                        background: "linear-gradient(100deg, #E0C3FC 0%, #8EC5FC 100%)",
                        boxShadow: "0 12px 48px 0 rgba(142,197,252,0.28), 0 4px 16px 0 rgba(224,195,252,0.18)",
                        transform: "scale(1.055)",
                        outline: "2.5px solid #8ec5fc",
                    },
                    "& .super-icon": {
                        zIndex: 1,
                        marginRight: 18,
                        filter: "drop-shadow(0 2px 8px #e0c3fcaa)",
                    },
                    "& .super-label": {
                        zIndex: 1,
                        letterSpacing: 2,
                        textShadow: "0 2px 8px #e0c3fc55",
                    }
                }}
                startIcon={
                    <span className="super-icon">
                        <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
                            <circle cx="19" cy="19" r="18" fill="#fff" fillOpacity="0.18" />
                            <circle cx="19" cy="19" r="14" fill="url(#g2)" />
                            <path d="M19 12v14M12 19h14" stroke="#fff" strokeWidth="2.8" strokeLinecap="round" />
                            <defs>
                                <linearGradient id="g2" x1="5" y1="5" x2="33" y2="33" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#8EC5FC" />
                                    <stop offset="1" stopColor="#E0C3FC" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </span>
                }
                onClick={() => navigate('/proforma')}
            >
                <span className="super-label">Dodaj fakturę</span>
            </Button>
        </Box>
    )
}

export default AddInvoiceButton;